import React from 'react';
import './CourseGenerationLoading.css';

const CourseGenerationLoading = ({ isVisible, progress, currentStep }) => {
  if (!isVisible) return null;

  const getStepText = (step) => {
    switch (step) {
      case 'analyzing':
        return 'Analyzing your learning goals...';
      case 'structuring':
        return 'Creating course structure...';
      case 'generating':
        return 'Generating lessons and content...';
      case 'finalizing':
        return 'Finalizing your course...';
      default:
        return 'Preparing your course...';
    }
  };

  return (
    <div className="course-generation-loading-overlay">
      <div className="course-generation-loading-container">
        <div className="loading-content">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>

          <div className="loading-text">
            <h3>Generating Your Course</h3>
            <p>{getStepText(currentStep)}</p>
          </div>

          <div className="loading-progress">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${Math.min(progress, 100)}%` }}
              />
            </div>
            <span className="progress-text">{Math.round(progress)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseGenerationLoading;